import { Loader2, ArrowRight, Eye, EyeOff } from "lucide-react";

const GoogleGIcon = () => (
  <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C33.9 6.2 29.2 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.6 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C33.9 6.2 29.2 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.6 26.7 36.5 24 36.5c-5.2 0-9.6-3.3-11.2-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.2-4.1 5.6l6.2 5.2C40.9 36 44 30.6 44 24c0-1.2-.1-2.4-.4-3.5z" />
  </svg>
);

export const LoginForm = ({ form, update, showPassword, setShowPassword, loading, onSubmit, onGoogle }) => (
  <>
    <form onSubmit={onSubmit} data-testid="signin-form" className="space-y-3">
      <input required type="email" data-testid="signin-email-input" placeholder="Email" value={form.email} onChange={update("email")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
      <div className="relative">
        <input
          required
          type={showPassword ? "text" : "password"}
          data-testid="signin-password-input"
          placeholder="Password"
          value={form.password}
          onChange={update("password")}
          className="w-full border border-rr-line rounded-lg px-4 py-3 pr-11 text-sm focus:outline-none focus:border-rr-orange"
        />
        <button
          type="button"
          onClick={() => setShowPassword((s) => !s)}
          data-testid="signin-toggle-password-visibility"
          aria-label={showPassword ? "Hide password" : "Show password"}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-rr-muted hover:text-rr-navy transition-colors"
        >
          {showPassword ? <EyeOff size={17} /> : <Eye size={17} />}
        </button>
      </div>
      <a
        href="mailto:support@relayrigs.com?subject=Password%20Reset%20Request&body=Hi%20RelayRigs%20team%2C%20I%20need%20help%20resetting%20my%20password%20for%20the%20account%20associated%20with%3A%20"
        data-testid="forgot-password-link"
        className="block text-right text-xs font-bold text-rr-muted hover:text-rr-orange transition-colors -mt-1"
      >
        Forgot your password? Contact support
      </a>
      <button type="submit" disabled={loading} data-testid="signin-submit-button" className="w-full bg-rr-navy text-white font-bold py-3.5 rounded-full hover:bg-rr-orange transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
        {loading ? <Loader2 size={18} className="animate-spin" /> : <>Sign In <ArrowRight size={16} /></>}
      </button>
    </form>

    <div className="flex items-center gap-3 py-1">
      <div className="flex-1 h-px bg-rr-line" />
      <span className="text-xs font-bold text-rr-muted uppercase">or</span>
      <div className="flex-1 h-px bg-rr-line" />
    </div>
    <button
      type="button"
      onClick={onGoogle}
      data-testid="google-signin-button"
      className="w-full border border-rr-line rounded-full py-3.5 text-sm font-bold text-rr-navy flex items-center justify-center gap-2 hover:bg-rr-surface transition-colors"
    >
      <GoogleGIcon />
      Continue with Google
    </button>
  </>
);
